export const exportPriceStatusOptions = [
  {
    label: 'Con export price',
    value: 'true',
  },
  {
    label: 'Sin export price',
    value: 'false',
  },
]
